import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=6f2727a7&scoped=true&"
import script from "./Recaptcha.vue?vue&type=script&lang=ts&"
export * from "./Recaptcha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2727a7",
  null
  
)

export default component.exports